/* unplugin-vue-components disabled */import script from "./doctor.vue?vue&type=script&setup=true&lang=ts"
export * from "./doctor.vue?vue&type=script&setup=true&lang=ts"

import "./doctor.vue?vue&type=style&index=0&id=535671e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535671e8"]])

export default __exports__